import { render } from "./LoadError.vue?vue&type=template&id=46838300"
import script from "./LoadError.vue?vue&type=script&lang=js"
export * from "./LoadError.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__